import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions} from "@angular/http";

import {SterbefallStatus} from '../model/enums';
import {Sterbefall} from '../model/sterbefall';
import {SterbefallIO} from '../model/sterbefall.io';

import {GuiProvider} from '../providers/gui.provider';
import {UserProvider} from '../providers/user.provider';
import {SterbefallProvider} from "./sterbefall.provider";
import {defaultServerUrl, apiVersion} from "../app/app.module";


@Injectable()
export class ServerProvider {

	serverUrl: string;

	constructor(
		private http: Http,
		private gui: GuiProvider,
		private sterbefaelle: SterbefallProvider,
		private users: UserProvider) {
		this.serverUrl = defaultServerUrl;
	}

	/**
	 * Speichert den gegebenen Sterbefall und sendet ihn an den Server.
	 * Zunächst wird der Server auf Kompatibilität geprüft, im Fehlerfall Abbruch.
	 * Ist kein Benutzer eingeloggt, ebenfalls Abbruch, ansonsten wird der Sterbefall
	 * übermittelt.
	 * Im Erfolgsfall wird der Status auf "gesendet" gesetzt, eine Meldung
	 * wird angezeigt und es wird zur Hauptseite navigiert. Ansonsten wird
	 * eine Nachricht mit dem Fehlergrund angezeigt.
	 */
	uploadSterbefall(sterbefall: Sterbefall) : void {

		//speichern
		this.sterbefaelle.saveSterbefall(sterbefall);

		//Benutzer eingeloggt?
		if (false == this.users.isLoggedIn())
			return;

		//Überprüfe Server-Version
		this.checkApiVersion().then(compatible => {
			if (compatible)
				this.doUploadSterbefall(sterbefall);
			else
				this.gui.showAlert("Update notwendig", "Vor dem Hochladen des Sterbefalls muss diese App aktualisiert werden. " +
					"Bitte laden Sie das Update aus dem App-Store.");
		}).catch(ex => {
			this.gui.showAlert("Fehler", "Der Sterbefall konnte nicht übermittelt werden. Prüfen Sie bitte Ihre Internetverbindung.");
		});
	}

	private doUploadSterbefall(sterbefall: Sterbefall): void {
		//Sterbefall kodieren mit Passwort
		let user = this.users.user;
		let sterbefallData = new SterbefallIO().saveSterbefall(sterbefall);
		let data = this.encrypt(JSON.stringify(sterbefallData), user.password);

		//Hochladen auf Server
		let url = this.serverUrl + "upload.php";
		let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
		let options = new RequestOptions({ headers: headers });
		let body = "key=upload_98R32fig237ftG&sterbefallid=" + sterbefall.id + "&userid=" + user.username + "&data=" + data;
		this.http.post(url, body, options).subscribe(
			response => {
				try {
					let result : any = response.json();
					if (result.result === 'fail') {
						this.gui.showAlert("Fehler", "Der Sterbefall konnte nicht übermittelt werden: " + result.message);
					}
					else if (result.result === 'success') {
						//Status auf "gesendet" setzen und erneut speichern
						sterbefall.status = SterbefallStatus.Gesendet;
						this.sterbefaelle.saveSterbefall(sterbefall);
						this.gui.showAlertAndPop("Übermittelt", "Der Sterbefall steht nun in Ruhe Sanft zum Abruf bereit.");
					}
				} catch(e) {
					this.gui.showAlert("Fehler", "Der Sterbefall konnte nicht übermittelt werden.");
				}
			},
			error => {
				this.gui.showAlert("Fehler", "Der Sterbefall konnte nicht übermittelt werden. Prüfen Sie bitte Ihre Internetverbindung.");
			}
		);
	}

	/**
	 * Überprüft, ob die API dieser App kompatibel ist mit dem Server.
	 * Dazu werden vom Server die unterstützten Versionsstände abgerufen und mit der
	 * App-API-Version abgeglichen. Im Erfolgsfall liefert die Ergebnis-Promise true,
	 * im Fehlerfall false.
	 */
	checkApiVersion() : Promise<boolean> {
		let url = this.serverUrl + "version.php";
		return new Promise<boolean>((resolve, reject) => {
			this.http.get(url).subscribe(
				response => {
					try {
						let result : any = response.json();
						resolve(result.versionsUpload.indexOf(apiVersion) > -1);
					} catch(e) {
						reject();
					}
				},
				error => {
					reject();
				}
			);
		});
	}

	/**
	 * Verschlüsselung: Im Moment (API 1.0) ein ganz simples XOR-Verfahren mit dem Passwort.
	 */
	encrypt(data: string, password: string) : string {
		var crypt = "";
		var data64 = window.btoa(encodeURIComponent(data));
		for (let i = 0; i < data64.length; i++) {
			let char = data64.charCodeAt(i) ^ password.charCodeAt(i % password.length);
			crypt += ("00" + char.toString(16)).substr(-2);
		}
		return crypt;
	}

}



// WEBPACK FOOTER //
// ./src/providers/server.provider.ts